require('slick-carousel');

function slickInit(item, nav, count, size, navFor, center, widthFull) {

    let sliderNavigate = $(nav);
    // let navForItem = navFor;
    let maxWidth = size;
    let slickVar = {
            // dots: true,
            // infinite: false,
            slidesToShow: count,
            slidesToScroll: 1,
            mobileFirst: true,
            variableWidth: widthFull,
            arrows: true,
            speed: 400,
            centerMode: center,
            // autoplay: true,
            autoplaySpeed: 7000,
            adaptiveHeight: true,
            asNavFor: navFor,
            appendArrows: sliderNavigate,
            prevArrow: '<div class="process__nav process__prev"><svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M21.2214 0.333C20.7774 -0.111 20.0784 -0.111 19.6344 0.333C19.2054 0.762 19.2054 1.476 19.6344 1.904L27.6814 9.951H1.12737C0.508367 9.951 0.000368118 10.443 0.000368118 11.062C0.000368118 11.681 0.508367 12.189 1.12737 12.189H27.6814L19.6344 20.221C19.2054 20.665 19.2054 21.38 19.6344 21.808C20.0784 22.252 20.7774 22.252 21.2214 21.808L31.1734 11.856C31.6024 11.427 31.6024 10.713 31.1734 10.285L21.2214 0.333Z" fill="#F0A929"/>\n' +
                '</svg></div>',
            nextArrow: '<div class="process__nav process__next"><svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M21.2214 0.333C20.7774 -0.111 20.0784 -0.111 19.6344 0.333C19.2054 0.762 19.2054 1.476 19.6344 1.904L27.6814 9.951H1.12737C0.508367 9.951 0.000368118 10.443 0.000368118 11.062C0.000368118 11.681 0.508367 12.189 1.12737 12.189H27.6814L19.6344 20.221C19.2054 20.665 19.2054 21.38 19.6344 21.808C20.0784 22.252 20.7774 22.252 21.2214 21.808L31.1734 11.856C31.6024 11.427 31.6024 10.713 31.1734 10.285L21.2214 0.333Z" fill="#F0A929"/>\n' +
                '</svg></div>',
            responsive: [
                {
                    breakpoint: maxWidth,
                    settings: 'unslick'
                },
                // {
                //     breakpoint: 768,
                //     settings: {
                //         slidesToShow: 1,
                //         variableWidth: true,
                //     }
                //
                // }
            ]
        },
        runSlick = function() {
            $(item).not('.slick-initialized').slick(slickVar);
        };

    runSlick();

    $(window).on('resize', function(){
        let windowWidth = $(window).width();
        if(windowWidth < maxWidth) {
            runSlick();
        }
    });

}
slickInit('.process__box-item', '', 5, 992, '.process__content-slider', true, true);
slickInit('.process__content-slider', '.process__content-navigate', 1, 992, '.process__box-item', '', false);



function processInit() {
    let processItems = $('.process__items');
    let processContentItems = $('.process__content-item');

    processItems.each(function(i, item) {

        $(item).on('click', function() {
            hideItem()
            showItem(i)
        })

    })
    showItem(1)
    function showItem(i) {
        $(processItems[i]).addClass('process__items--active')
        $(processContentItems[i]).addClass('process__content-item--active')
    }
    function hideItem() {
        processItems.each(function(i, item) {
            $(item).removeClass('process__items--active')
        })
        processContentItems.each(function(i, item) {
            $(item).removeClass('process__content-item--active')
        })
    }

}
$( document ).ready(function() {
    if($('.process__items').length) {
        processInit();
    }
});
